import { amber, lightGreen, lime, orange, red, yellow } from "@mui/material/colors";

export const STRENGTH_COLORS = [
  lightGreen[500],
  lightGreen[600],
  lime[500],
  yellow[600],
  yellow[700],
  amber[600],
  orange[600],
  red[400],
  red[500],
  red[600],
];

export const numberToColor = (number: number, threshold: number = 48) => {
  const intervalSize = threshold / (STRENGTH_COLORS.length - 1);
  const index = Math.floor(number / intervalSize);
  const colorIndex = Math.min(index, STRENGTH_COLORS.length - 1);
  return STRENGTH_COLORS[colorIndex];
};
